import { ObstacleEffect } from './ObstacleEffect';
import type Obstacle from './entities/obstacle/Obstacle';
// import ObstacleBananaSkin from './entities/obstacle/ObstacleBananaSkin';
// import ObstacleBoxes from './entities/obstacle/ObstacleBoxes';
// import ObstacleOilSlick from './entities/obstacle/ObstacleOilSlick';
// import ObstacleWetConcrete from './entities/obstacle/ObstacleWetConcrete';
// import ObstacleIcePatch from './entities/obstacle/ObstacleIcePatch';
// import ObstacleMudPatch from './entities/obstacle/ObstacleMudPatch';
// import ObstacleSnowDrift from './entities/obstacle/ObstacleSnowDrift';
// import ObstacleLeafPile from './entities/obstacle/ObstacleLeafPile';

export class ObstacleEffectController {
  public static events = {
    ShowEffect: 'showEffect'
  } as const;

  protected scene: Phaser.Scene;
  protected obstacleEffectLayer: Phaser.GameObjects.Layer;

  protected freePool: Set<ObstacleEffect>;
  protected livePool: Set<ObstacleEffect>;

  constructor(scene: Phaser.Scene, obstacleEffectLayer: Phaser.GameObjects.Layer) {
    this.scene = scene;
    this.obstacleEffectLayer = obstacleEffectLayer;

    this.freePool = new Set();
    this.livePool = new Set();

    this.scene.events.on(ObstacleEffectController.events.ShowEffect, this.showEffect, this);
    this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.update, this);
    this.scene.events.once(Phaser.Scenes.Events.SHUTDOWN, this.shutdown, this);
  }

  public showEffect(obstacle: Obstacle, x: number, y: number) {
    if (this.freePool.size <= 0) {
      this.addToPool();
    }

    let effect: ObstacleEffect = this.freePool.values().next().value;
    this.freePool.delete(effect);
    effect.init();
    effect.x = x;
    effect.y = y;
    effect.setVisible(true);
    // effect.setActive(true);
    this.setTargetObstacle(effect, obstacle);

    this.livePool.add(effect);
  }

  public setTargetObstacle(effect: ObstacleEffect, targetObstacle: Obstacle) {
    let skin: string = '';
    let animation: string = '';
    let shouldLoop: boolean = false;

    // if (targetObstacle instanceof ObstacleBananaSkin) {
    //   skin = 'banana';
    //   animation = 'splash';
    // } else if (targetObstacle instanceof ObstacleBoxes) {
    //   skin = 'boxes';
    //   animation = 'box-smash';
    // } else if (targetObstacle instanceof ObstacleOilSlick) {
    //   skin = 'oil';
    //   animation = 'splash';
    // } else if (targetObstacle instanceof ObstacleWetConcrete) {
    //   skin = 'concrete';
    //   animation = 'splash';
    // } else if (targetObstacle instanceof ObstacleIcePatch) {
    //   skin = 'ice';
    //   animation = 'splash';
    // } else if (targetObstacle instanceof ObstacleMudPatch) {
    //   skin = 'mud';
    //   animation = 'splash';
    // } else if (targetObstacle instanceof ObstacleLeafPile) {
    //   skin = 'leaves';
    //   animation = 'splash';
    // } else if (targetObstacle instanceof ObstacleSnowDrift) {
    //   skin = 'snow';
    //   animation = 'splash';
    // }

    effect.setTargetObstacle(skin, animation, shouldLoop);
  }

  public update() {
    // for (const obstacleEffect of this.livePool) {
    //   if (!obstacleEffect.IsInUse) {
    //     this.livePool.delete(obstacleEffect);
    //     obstacleEffect.init();
    //     this.freePool.add(obstacleEffect);
    //   }
    // }
  }

  protected addToPool() {
    let effect = new ObstacleEffect(this.scene, 0, 0);
    effect.init();
    effect.setVisible(false);
    // effect.setActive(false);

    effect.addToUpdateList();
    this.obstacleEffectLayer.add(effect as unknown as Phaser.GameObjects.GameObject);
    this.freePool.add(effect);
    console.log(`Adding to pool, pool now ${this.freePool.size} and ${this.livePool.size} big`);
  }

  protected shutdown() {
    this.scene.events.off(ObstacleEffectController.events.ShowEffect, this.showEffect, this);
    this.scene.events.off(Phaser.Scenes.Events.UPDATE, this.update, this);
  }
}
